import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  BookOpen, 
  FileText, 
  Users, 
  UserCheck, 
  GraduationCap,
  Briefcase
} from 'lucide-react';

function AdminLayout() {
  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <nav className="col-md-2 d-md-block bg-light sidebar" style={{ minHeight: '100vh' }}>
          <div className="position-sticky pt-3">
            <h5 className="px-3 mb-3 text-muted">Admin Panel</h5>
            <ul className="nav flex-column">
              <li className="nav-item">
                <NavLink 
                  to="/admin/dashboard" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active bg-primary text-white' : ''}`}
                >
                  <LayoutDashboard className="me-2" size={18} />
                  Dashboard
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/admin/programs" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active bg-primary text-white' : ''}`}
                >
                  <BookOpen className="me-2" size={18} />
                  Programs
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/admin/assessments" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active bg-primary text-white' : ''}`}
                >
                  <FileText className="me-2" size={18} />
                  Assessments
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/admin/content" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active bg-primary text-white' : ''}`}
                >
                  <GraduationCap className="me-2" size={18} />
                  Content
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/admin/enrollments" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active bg-primary text-white' : ''}`}
                >
                  <UserCheck className="me-2" size={18} />
                  Enrollments
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/admin/internships" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active bg-primary text-white' : ''}`}
                >
                  <Briefcase className="me-2" size={18} />
                  Internships
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  to="/admin/students" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active bg-primary text-white' : ''}`}
                >
                  <Users className="me-2" size={18} />
                  Students
                </NavLink>
              </li>
            </ul>
            
            <hr className="my-3" />
            
            <div className="px-3">
              <NavLink to="/dashboard" className="btn btn-sm btn-outline-secondary w-100">
                ← Back to Dashboard
              </NavLink>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main className="col-md-10 ms-sm-auto px-md-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
